import { Menu, Transition } from '@headlessui/react'
import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'
import { Fragment } from 'react'

import { Langs } from '@/types/Common'

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ')
}

const LanguageDropdown: React.FC = () => {
  const { lang } = useTranslation()
  const router = useRouter()

  const languages = [
    { code: 'ru', label: 'Ру' },
    { code: 'uz', label: "O'z" },
    { code: 'en', label: 'En' },
  ]

  const currentLanguage = languages.find((language) => language.code === lang)

  const onLangChange = (lang: Langs) => {
    router.push(
      {
        pathname: router.pathname,
        query: router.query,
      },
      router.asPath,
      {
        locale: lang,
        scroll: false,
      }
    )
  }

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500">
          {currentLanguage?.label}
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 w-full mt-2 origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            {languages.map((language) => (
              <Menu.Item key={language.code}>
                {({ active }) => (
                  <button
                    onClick={() => onLangChange(language.code as Langs)}
                    className={classNames(
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'block px-4 py-2 text-sm w-full'
                    )}
                  >
                    {language.label}
                  </button>
                )}
              </Menu.Item>
            ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}

export default LanguageDropdown
